import {Observable} from 'rxjs';

export abstract class DomainResolver {
  abstract get domainName$(): Observable<string>;
  abstract get api(): string;
  abstract resolveToken(token: string): any;
  abstract get isOffline(): Observable<boolean>;
}
